module.exports = __webpack_public_path__ + "static/img/bg_shengjizongheti.ef50542.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/bg_shengjizongheti.png
// module id = F6QP
// module chunks = 1